const actions = {
    SET_MESSAGE: ({ commit }, payload) => {
        commit('COMMIT_MESSAGE', payload)

        setTimeout(() => {
            commit('COMMIT_MESSAGE', '')
        }, 10000)
    },

    SET_MESSAGE_TYPE: ({ commit }, payload) => {
        commit('COMMIT_MESSAGE_TYPE', payload)
    },

    SET_WARNING: ({ commit }, payload) => {
        commit('COMMIT_WARNING', payload)

        setTimeout(() => {
            commit('COMMIT_WARNING', '')
        }, 10000)
    },
}

export default actions
